import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import { addExpense, getTransactions, getOrgTransactions, getSuspenseTransactions, deleteSuspense, addBilling, getBillingTransactions } from './expenseMiddleware';
import { type Expense } from './expenseTypes';

export const addExpenseAction = async (
  dispatch: AppDispatch,
  payload: Expense
) => {
  const data = {
    ...payload,
  };
  const res = await dispatch(addExpense(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Expense added successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating expense'));
    return false;
  }
};

export const getTransactionsAction = async (
  dispatch: AppDispatch,
  payload: { branch?: string, startDate: string, endDate: string }
) => {
  const res = await dispatch(getTransactions(payload));
  console.log(res);
};

export const getOrgTransactionsAction = async (
  dispatch: AppDispatch,
  payload: { branch: string, startDate: string, endDate: string }
) => {
  const res = await dispatch(getOrgTransactions(payload));
  console.log(res);
};

export const getSuspenseTransactionsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getSuspenseTransactions(payload));
  console.log(res);
};

export const deleteSuspenseAction = async (
  dispatch: AppDispatch,
  payload: {id: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(deleteSuspense(data));

  
  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Suspense deleted Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error deleting suspense'));
    return false;
  }
};

export const addBillingAction = async (
  dispatch: AppDispatch,
  payload: Expense
) => {
  const res = await dispatch(addBilling(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Billing added successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error adding billing'));
    return false;
  }
};

export const getBillingTransactionsAction = async (
  dispatch: AppDispatch,
  payload: { branch: string, startDate: string, endDate: string }
) => {
  await dispatch(getBillingTransactions(payload));
};
